import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import useLazy from 'shared/hoc/withLazy';
import { sections } from 'constants/about';
import { useTranslation } from 'react-i18next';
import { languages } from 'constants/localization';
const Homepage = useLazy(() => import('app/website/Homepage'));
// about components/subcomponents //
const About = useLazy(() => import('app/website/About'));
const OrgStructure = useLazy(() => import('app/website/About/OrgStructure'));
const Member = useLazy(() => import('app/website/About/Member'));
const Partner = useLazy(() => import('app/website/About/Partner'));
// activity components/subcomponents //
const Activity = useLazy(() => import('app/website/Activity'));
const ConfirmedProjects = useLazy(() => import('app/website/Activity/ConfirmedProjects'));
const CurrentProjects = useLazy(() => import('app/website/Activity/CurrentProjects'));
const Events = useLazy(() => import('app/website/Activity/Events'));
// news components/subcomponents //
const News = useLazy(() => import('app/website/News'));
// for single event/news
const SingleItem = useLazy(() => import('app/website/SingleItem'));
// material components/subcomponents //
const Materials = useLazy(() => import('app/website/Materials'));
const UsefulLinks = useLazy(() => import('app/website/Materials/UsefulLinks'));
const Archive = useLazy(() => import('app/website/Materials/Archive'));
const Books = useLazy(() => import('app/website/Materials/Books'));
const Articles = useLazy(() => import('app/website/Materials/Articles'));
const MaterialItem = useLazy(() => import('app/website/Materials/Item'));
// static pages
const PrivacyPolicy = useLazy(() => import('app/website/StaticPages/PrivacyPolicy'));
const TermsOfUse = useLazy(() => import('app/website/StaticPages/TermsOfUse'));
// other  pages//
const Search = useLazy(() => import('app/website/Search'));
const Contact = useLazy(() => import('app/website/Contact'));
const Vacancies = useLazy(() => import('app/website/Vacancies'));
const AdminLogin = useLazy(() => import('app/admin/login'));
const Page404 = useLazy(() => import('app/website/404'));

export const websiteRoutes = (orgs) => [
  {
    id: 1,
    path: '/',
    exact: true,
    t_key: 'homepage',
    component: Homepage,
    isMenuItem: false,
  },
  {
    id: 2,
    path: '/about',
    exact: true,
    t_key: 'about',
    isMenuItem: true,
    isDropdown: true,
    component: About,
    subRoutes: [
      {
        id: 2.1,
        exact: true,
        isDropdownItem: true,
        path: '/about/org_structure',
        t_key: 'org_structure',
        component: OrgStructure,
        subRoutes: [
          {
            id: 2.11,
            path: `/about/org_structure#${orgs && orgs[0]._id}`,
            t_key: `trustee_council`,
          },
          {
            id: 2.12,
            path: `/about/org_structure#${orgs && orgs[1]._id}`,
            t_key: `science_council`,
          },
          {
            id: 2.13,
            path: `/about/org_structure#${sections.partners}`,
            t_key: `partners`,
          },
        ],
      },
      {
        id: 2.2,
        exact: true,
        isDropdownItem: false,
        path: '/about/org_structure/:id',
        t_key: 'person',
        component: Member,
      },
      {
        id: 2.3,
        exact: true,
        isDropdownItem: false,
        path: '/about/partners/:id',
        t_key: 'partners',
        component: Partner,
      },
    ],
  },

  {
    id: 3.1,
    isMenuItem: false,
    path: '/activity/:type/:id',
    t_key: 'events',
    component: SingleItem,
  },
  {
    id: 4,
    path: '/activity',
    exact: true,
    t_key: 'activity',
    isMenuItem: true,
    isDropdown: true,
    component: Activity,
    subRoutes: [
      {
        id: 4.1,
        exact: true,
        isDropdownItem: true,
        path: '/activity/events',
        t_key: 'events',
        component: Events,
      },
      {
        id: 4.2,
        exact: true,
        isDropdownItem: true,
        path: '/activity/current_projects',
        t_key: 'current_projects',
        component: CurrentProjects,
      },
      {
        id: 4.3,
        exact: true,
        isDropdownItem: true,
        path: '/activity/confirmed_projects',
        t_key: 'confirmed_projects',
        component: ConfirmedProjects,
      },
    ],
  },

  {
    id: 5,
    path: '/news',
    t_key: 'news',
    component: News,
    isMenuItem: true,
    isDropdown: false,
    exact: true,
    subRoutes: [
      {
        id: 5.1,
        isDropdownItem: false,
        path: '/news/:id',
        t_key: `news`,
        component: SingleItem,
      },
    ],
  },
  // material links
  {
    id: 6,
    path: '/materials',
    exact: true,
    t_key: 'materials',
    isMenuItem: true,
    isDropdown: true,
    component: Materials,
    subRoutes: [
      {
        id: 6.1,
        exact: true,
        isDropdownItem: true,
        path: '/materials/:type/books',
        t_key: `digital_library`,
        component: Books,
        subRoutes: [
          {
            id: 6.11,
            path: '/materials/digital_library/books',
            t_key: 'books',
          },
          {
            id: 6.12,
            path: '/materials/digital_library/articles',
            t_key: 'articles',
          },
        ],
      },
      {
        id: 6.2,
        exact: true,
        isDropdownItem: true,
        path: '/materials/:type/articles',
        t_key: 'bibliography',
        component: Articles,
        subRoutes: [
          {
            id: 6.21,
            path: '/materials/bibliography/books',
            t_key: 'books',
          },
          {
            id: 6.22,
            path: '/materials/bibliography/articles',
            t_key: 'articles',
          },
        ],
      },
      {
        id: 6.3,
        exact: true,
        path: '/materials/useful_links',
        t_key: 'useful_links',
        component: UsefulLinks,
        isMenuItem: true,
        isDropdownItem: true,
      },
      {
        id: 6.4,
        exact: true,
        path: '/materials/archive_aniv',
        t_key: `archive_aniv`,
        isMenuItem: true,
        component: Archive,
        isDropdownItem: true,
      },
      {
        id: 6.5,
        isDropdownItem: false,
        path: '/materials/:section/:type/:id',
        isMenuItem: false,
        component: MaterialItem,
      },
      {
        id: 6.6,
        isDropdownItem: false,
        path: '/materials/:section/:id',
        isMenuItem: false,
        component: MaterialItem,
      },
    ],
  },
  {
    id: 7,
    path: '/contact',
    t_key: 'contact',
    isMenuItem: true,
    component: Contact,
  },
  {
    id: 8,
    path: '/vacancies',
    t_key: 'vacancies',
    isMenuItem: true,
    component: Vacancies,
  },

  {
    id: 9,
    path: '/admin',
    exact: true,
    t_key: 'admin_panel',
    component: AdminLogin,
    isMenuItem: false,
  },
  {
    id: 10,
    path: '/search',
    exact: true,
    t_key: 'search',
    component: Search,
    isMenuItem: false,
  },
  {
    id: 11,
    path: '/search/tags/:id',
    exact: true,
    t_key: 'search',
    component: Search,
    isMenuItem: false,
  },
  {
    id: 12,
    path: '/privacy_policy',
    exact: true,
    t_key: 'privacy_policy',
    component: PrivacyPolicy,
    isMenuItem: false,
  },
  {
    id: 13,
    path: '/terms_of_use',
    exact: true,
    t_key: 'terms_of_use',
    component: TermsOfUse,
    isMenuItem: false,
  },
  {
    id: 14,
    path: '/page_not_found',
    component: Page404,
    isMenuItem: false,
  },
];

export default () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  return (
    <Switch>
      {/* define  root routes */}
      {websiteRoutes().map((route) => (
        <Route
          key={route.id}
          exact={route.exact}
          path={`${language !== languages.ru.code ? `/${language}` : ''}${route.path}`}
          render={() => <route.component />}
        />
      ))}
      {/* define  subroutes  */}
      {websiteRoutes().map(
        (route) =>
          route.subRoutes &&
          route.subRoutes.map((subroute) => (
            <Route
              key={subroute.id}
              exact={subroute.exact}
              path={`${language !== languages.ru.code ? `/${language}` : ''}${subroute.path}`}
              render={() => <subroute.component />}
            />
          ))
      )}

      <Redirect from='/about/' to='/about' />
      <Redirect from='/materials/' to='/materials' />
      <Redirect from='/am/about/' to='/am/about' />
      <Redirect from='/am/materials/' to='/am/materials' />
      <Redirect from='/en/about/' to='/en/about' />
      <Redirect from='/en/materials/' to='/en/materials' />
      <Redirect to='/page_not_found' />
    </Switch>
  );
};
